export const PRODUCT_TYPES = {
  MEMBERSHIP: 'MEMBERSHIP',
  LIFETIME: 'LIFETIME',
  FANCLUB: 'FANCLUB',
  ITEM: 'ITEM',
  GIFT: 'GIFT',
  CAMEO_NUDE: 'CAMEO_NUDE',
  CAMEO_NON_NUDE: 'CAMEO_NON_NUDE',
};
